// ───────────────────────────────────────────────────────────────────
// Rob Power — Buyers Agent · content
// Stats auto-compute from the `properties` array below.
// To add a new property, append a new object to `properties`.
// ───────────────────────────────────────────────────────────────────

export const properties = [
  {
    location: "Darwin, NT",
    dealType: "SMSF",
    purchaseDate: "2025-02",
    purchaseLabel: "February 2025",
    purchase: 490000,
    current: 640000,
    yield: null,
    beds: 3, baths: 1, cars: 2, land: "966m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/2impkmn5_image.png"
  },
  {
    location: "North Melbourne, VIC",
    purchaseDate: "2025-04",
    purchaseLabel: "April 2025",
    purchase: 683000,
    current: 780000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "583m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/1flima60_image.png"
  },
  {
    location: "Darwin, NT",
    dealType: "Off Market",
    purchaseDate: "2025-04",
    purchaseLabel: "April 2025",
    purchase: 552000,
    current: 712000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "360m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/dr0ypk72_image.png"
  },
  {
    location: "North Melbourne, VIC",
    purchaseDate: "2025-04",
    purchaseLabel: "April 2025",
    purchase: 660000,
    current: 755000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "601m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/ac2nm68q_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-05",
    purchaseLabel: "May 2025",
    purchase: 650000,
    current: 829000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "519m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/if5016qq_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-05",
    purchaseLabel: "May 2025",
    purchase: 650000,
    current: 812000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "484m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/nnezcurc_image.png"
  },
  {
    location: "North Melbourne, VIC",
    purchaseDate: "2025-05",
    purchaseLabel: "May 2025",
    purchase: 685000,
    current: 734000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "350m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/k0wf4bsm_image.png"
  },
  {
    location: "Darwin, NT",
    dealType: "Off Market",
    purchaseDate: "2025-06",
    purchaseLabel: "June 2025",
    purchase: 680000,
    current: 830000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "449m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/fejj4z1f_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-06",
    purchaseLabel: "June 2025",
    purchase: 560000,
    current: 642000,
    yield: null,
    beds: 3, baths: 1, cars: 2, land: "517m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/zdrwnd6y_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-06",
    purchaseLabel: "June 2025",
    purchase: 655000,
    current: 875000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "802m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/17ka1l83_image.png"
  },
  {
    location: "North Melbourne, VIC",
    dealType: "Off Market",
    purchaseDate: "2025-07",
    purchaseLabel: "July 2025",
    purchase: 650000,
    current: 735000,
    yield: null,
    beds: 4, baths: 2, cars: 4, land: "350m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/2wcgiayt_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-07",
    purchaseLabel: "July 2025",
    purchase: 700000,
    current: 840000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "419m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/47ui0vig_image.png"
  },
  {
    location: "Darwin, NT",
    purchaseDate: "2025-07",
    purchaseLabel: "July 2025",
    purchase: 782000,
    current: 850000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "487m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/lqa61i2p_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-08",
    purchaseLabel: "August 2025",
    purchase: 710000,
    current: 810000,
    yield: null,
    beds: 4, baths: 2, cars: 4, land: "774m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/rpct4uoe_image.png"
  },
  {
    location: "Darwin, NT",
    dealType: "Off Market",
    purchaseDate: "2025-08",
    purchaseLabel: "August 2025",
    purchase: 710000,
    current: 826000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "603m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/mu4c0w04_image.png"
  },
  {
    location: "North Melbourne, VIC",
    purchaseDate: "2025-08",
    purchaseLabel: "August 2025",
    purchase: 680000,
    current: 730000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "349m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/4fs8fflu_image.png"
  },
  {
    location: "Regional NSW",
    feature: "Granny Flat Potential",
    dealType: "Off Market",
    purchaseDate: "2025-09",
    purchaseLabel: "September 2025",
    purchase: 560000,
    current: 673000,
    yield: null,
    beds: 3, baths: 2, cars: 1, land: "702m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/d1czsd0j_image.png"
  },
  {
    location: "North Melbourne, VIC",
    purchaseDate: "2025-10",
    purchaseLabel: "October 2025",
    purchase: 705000,
    current: 740000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "392m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/nz83hjmm_image.png"
  },
  {
    location: "Darwin, NT",
    dealType: "Off Market",
    purchaseDate: "2025-09",
    purchaseLabel: "September 2025",
    purchase: 700000,
    current: 795000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "508m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/jlq7rr2g_image.png"
  },
  {
    location: "North Melbourne, VIC",
    dealType: "Off Market",
    purchaseDate: "2025-09",
    purchaseLabel: "September 2025",
    purchase: 710000,
    current: 740000,
    yield: null,
    beds: 4, baths: 2, cars: 4, land: "392m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/074ae3jm_image.png"
  },
  {
    location: "Regional NSW",
    dealType: "Off Market",
    purchaseDate: "2025-08",
    purchaseLabel: "August 2025",
    purchase: 525000,
    current: 619000,
    yield: null,
    beds: 3, baths: 1, cars: 1, land: "620m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/lnnjecgl_image.png"
  },
  {
    location: "Darwin, NT",
    dealType: "Off Market",
    purchaseDate: "2025-09",
    purchaseLabel: "September 2025",
    purchase: 785000,
    current: 866000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "629m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/0cmtn1mt_image.png"
  },
  {
    location: "Regional NSW",
    dealType: "Off Market",
    purchaseDate: "2025-08",
    purchaseLabel: "August 2025",
    purchase: 480000,
    current: 598000,
    yield: null,
    beds: 3, baths: 1, cars: 1, land: "589m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/q71pj6ss_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "SMSF",
    purchaseDate: "2025-09",
    purchaseLabel: "September 2025",
    purchase: 798000,
    current: 880000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "667m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/2k5ae3ho_image.png"
  },
  {
    location: "Cairns, QLD",
    purchaseDate: "2025-08",
    purchaseLabel: "August 2025",
    purchase: 742000,
    current: 861000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "392m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/xcxt2wfs_image.png"
  },
  {
    location: "Palmerston, Darwin NT",
    dealType: "Off Market",
    purchaseDate: "2025-09",
    purchaseLabel: "September 2025",
    purchase: 702000,
    current: 770000,
    yield: null,
    beds: 3, baths: 3, cars: 2, land: "382m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/uqm7tv8w_image.png"
  },
  {
    location: "Launceston, TAS",
    dealType: "SMSF",
    type: "Block of Units",
    purchaseDate: "2025-11",
    purchaseLabel: "November 2025",
    purchase: 695000,
    current: 740000,
    yield: null,
    beds: 4, baths: 3, cars: 3, land: null,
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/z0jj5gjk_image.png"
  },
  {
    location: "Cairns, QLD",
    feature: "Subdivision Potential",
    dealType: "Off Market",
    purchaseDate: "2025-11",
    purchaseLabel: "November 2025",
    purchase: 625000,
    current: 725000,
    yield: null,
    beds: 4, baths: 1, cars: 1, land: "784m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/z60b21f8_image.png"
  },
  {
    location: "Brisbane, QLD",
    feature: "Granny Flat Potential",
    purchaseDate: "2025-11",
    purchaseLabel: "November 2025",
    purchase: 925000,
    current: 1000000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "800m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/l3gb44g8_image.png"
  },
  {
    location: "Hobart, TAS",
    dealType: "Off Market",
    purchaseDate: "2025-11",
    purchaseLabel: "November 2025",
    purchase: 600000,
    current: 675000,
    yield: null,
    beds: 3, baths: 1, cars: 1, land: "572m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/qj32es1w_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "Off Market",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 740000,
    current: 830000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "550m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/496pov8b_image.png"
  },
  {
    location: "Launceston, TAS",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 640000,
    current: 690000,
    yield: null,
    beds: 3, baths: 1, cars: 2, land: "685m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/aqdxdsw6_image.png"
  },
  {
    location: "Hobart, TAS",
    feature: "Renovator",
    dealType: "Off Market",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 800000,
    current: 940000,
    renovation: 40000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "695m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/1xjvktin_image.png"
  },
  {
    location: "Hobart, TAS",
    dealType: "Trust Account",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 800000,
    current: 840000,
    yield: null,
    beds: 4, baths: 2, cars: 6, land: "529m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/j66me894_image.png"
  },
  {
    location: "West Melbourne, VIC",
    dealType: "Off Market",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 725000,
    current: 770000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "400m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/7somi3rk_image.png"
  },
  {
    location: "North Melbourne, VIC",
    feature: "SMSF Purchase",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 650000,
    current: 695000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "300m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/wxakz9w2_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "Pre-Market",
    purchaseDate: "2026-01",
    purchaseLabel: "January 2026",
    purchase: 720000,
    current: 797000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "445m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/8zbpe51z_image.png"
  },
  {
    location: "Redbank Plains, QLD",
    dealType: "Off Market",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 790000,
    current: 867000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "339m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/xd9mxlh2_image.png"
  },
  {
    location: "Launceston, TAS",
    dealType: "Off Market",
    purchaseDate: "2026-01",
    purchaseLabel: "January 2026",
    purchase: 655000,
    current: 696000,
    yield: null,
    beds: 3, baths: 2, cars: 1, land: "699m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/ckuf9drk_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "Pre-Market",
    purchaseDate: "2025-12",
    purchaseLabel: "December 2025",
    purchase: 615000,
    current: 673000,
    yield: null,
    beds: 3, baths: 1, cars: 1, land: "726m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/7kfc4krq_image.png"
  },
  {
    location: "Launceston, TAS",
    dealType: "Off Market",
    feature: "Renovator · Granny Flat Potential",
    purchaseDate: "2026-02",
    purchaseLabel: "February 2026",
    purchase: 530000,
    current: 595000,
    renovation: 25000,
    yield: null,
    beds: 3, baths: 1, cars: 5, land: "819m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/k32bjncc_image.png"
  },
  {
    location: "Launceston, TAS",
    dealType: "Pre-Market",
    purchaseDate: "2026-02",
    purchaseLabel: "February 2026",
    purchase: 630000,
    current: 668000,
    yield: null,
    beds: 3, baths: 1, cars: 2, land: "697m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/82sex66t_image.png"
  },
  {
    location: "West Melbourne, VIC",
    dealType: "Off Market",
    feature: "Renovator",
    purchaseDate: "2026-03",
    purchaseLabel: "March 2026",
    purchase: 600000,
    current: 630000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "614m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/5899e6oj_image.png"
  },
  {
    location: "East Melbourne, VIC",
    dealType: "Pre-Market",
    purchaseDate: "2026-03",
    purchaseLabel: "March 2026",
    purchase: 750000,
    current: 764000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "349m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/6p7x61a1_image.png"
  },
  {
    location: "Brisbane, QLD",
    type: "Unit",
    dealType: "First Homeowner",
    feature: "5% Deposit Scheme",
    purchaseDate: "2026-03",
    purchaseLabel: "March 2026",
    purchase: 1000000,
    current: 1060000,
    yield: null,
    beds: 3, baths: 2, cars: 1, land: "206m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/x5aelpd5_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "Pre-Market",
    purchaseDate: "2025-02",
    purchaseLabel: "February 2025",
    purchase: 719000,
    current: 775000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "512m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/l0ppozx3_image.png"
  },
  {
    location: "Launceston, TAS",
    dealType: "Off Market",
    feature: "2-Bed Converted to 3-Bed",
    purchaseDate: "2026-04",
    purchaseLabel: "April 2026",
    purchase: 512000,
    current: 600000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "802m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/4ho4syxk_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "Off Market",
    purchaseDate: "2026-05",
    purchaseLabel: "May 2026",
    purchase: 710000,
    current: 735000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "550m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/3x1c1kkj_image.png"
  },
  {
    location: "Regional VIC",
    dealType: "SMSF",
    purchaseDate: "2026-04",
    purchaseLabel: "April 2026",
    purchase: 575000,
    current: 589000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "348m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/g35ui72v_image.png"
  },
  {
    location: "Regional VIC",
    dealType: "Off Market",
    purchaseDate: "2026-04",
    purchaseLabel: "April 2026",
    purchase: 605000,
    current: 612000,
    yield: null,
    beds: 3, baths: 2, cars: 2, land: "378m²",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/2a6c7uqz_Screenshot%202026-06-10%20083342.png"
  },
  {
    location: "Sunshine Coast, QLD",
    dealType: "Owner Occupier",
    feature: "Multiple Income Streams",
    purchaseDate: "2026-05",
    purchaseLabel: "May 2026",
    purchase: 1330000,
    current: 1410000,
    yield: null,
    beds: 5, baths: 3, cars: 4, land: "2.02 ha",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/4rmrbdr4_image.png"
  },
  {
    location: "Launceston, TAS",
    dealType: "House with Granny Flat",
    purchaseDate: "2026-05",
    purchaseLabel: "May 2026",
    purchase: 610000,
    current: 620000,
    yield: null,
    beds: 3, baths: 2, cars: 4, land: "741m²",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/jugeivb3_image.png"
  },
  {
    location: "Ipswich, QLD",
    dealType: "Off Market",
    purchaseDate: "2019-02",          // ISO YYYY-MM, used for CAGR math
    purchaseLabel: "February 2019",   // shown on the card
    purchase: 305000,
    current: 912000,
    yield: null,                      // not provided → hides the yield badge
    beds: 3, baths: 1, cars: 1, land: "1,350m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/my7yl1zk_image.png"
  },
  {
    location: "Bundaberg, QLD",
    dealType: "Off Market",
    purchaseDate: "2024-07",
    purchaseLabel: "July 2024",
    purchase: 470000,
    current: 660000,
    yield: null,
    beds: 3, baths: 1, cars: 1, land: "554m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/n1h4griw_image.png"
  },
  {
    location: "Albury, NSW",
    dealType: "Off Market",
    purchaseDate: "2021-03",
    purchaseLabel: "March 2021",
    purchase: 360000,
    current: 664000,
    yield: null,
    beds: 3, baths: 1, cars: 2, land: "648m²",
    image: "https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/tuj5u0un_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "SMSF",
    purchaseDate: "2026-05",
    purchaseLabel: "May 2026",
    purchase: 844500,
    current: 865000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "851m²",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/vyg2rfp7_image.png"
  },
  {
    location: "Cairns, QLD",
    dealType: "SMSF",
    purchaseDate: "2026-06",
    purchaseLabel: "June 2026",
    purchase: 730000,
    current: 730000,
    yield: null,
    beds: 3, baths: 1, cars: 2, land: "480m²",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/faaipq7o_image.png"
  },
  {
    location: "North Melbourne, VIC",
    purchaseDate: "2025-05",
    purchaseLabel: "May 2025",
    purchase: 680000,
    current: 740000,
    yield: null,
    beds: 4, baths: 2, cars: 2, land: "390m²",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/2or13tyy_image.png"
  },
  {
    location: "North Melbourne, VIC",
    dealType: "Renovator",
    purchaseDate: "2026-03",
    purchaseLabel: "March 2026",
    purchase: 710000,
    current: 820000,
    yield: null,
    beds: 4, baths: 2, cars: 1, land: "715m²",
    image: "https://customer-assets.emergentagent.com/job_671a4a5d-28d2-4d93-ab5c-2384aee86271/artifacts/1dx831ee_image.png"
  }
];

// ── Computation helpers ────────────────────────────────────────────

const yearsHeld = (isoYearMonth) => {
  const [y, m] = isoYearMonth.split("-").map(Number);
  const purchase = new Date(y, m - 1, 1);
  const now = new Date();
  return Math.max(0.1, (now - purchase) / (365.25 * 24 * 60 * 60 * 1000));
};

export const propertyMetrics = (p) => {
  const growth = p.current - p.purchase;
  const growthPct = (growth / p.purchase) * 100;
  const years = yearsHeld(p.purchaseDate);
  const cagr = (Math.pow(p.current / p.purchase, 1 / years) - 1) * 100;
  return { growth, growthPct, years, cagr };
};

// ── Stats auto-computed from properties ────────────────────────────

const fmtBig = (n) => {
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n}`;
};

export const computeStats = (props) => {
  if (props.length === 0) {
    return [
      { value: "—", label: "Properties Secured" },
      { value: "—", label: "Client Portfolio Value" },
      { value: "—", label: "Client Equity Created" },
      { value: "—", label: "Avg. Annualised Growth" }
    ];
  }
  const portfolio = props.reduce((s, p) => s + p.current, 0);
  const equity = props.reduce((s, p) => s + (p.current - p.purchase), 0);
  const avgCagr =
    props.reduce((s, p) => s + propertyMetrics(p).cagr, 0) / props.length;
  return [
    { value: String(props.length), label: "Properties Secured" },
    { value: fmtBig(portfolio), label: "Client Portfolio Value" },
    { value: fmtBig(equity), label: "Client Equity Created" },
    { value: `${avgCagr.toFixed(1)}%`, label: "Avg. Annualised Growth" }
  ];
};

// ── Static content ─────────────────────────────────────────────────

export const principles = [
  {
    title: "Data Over Emotion",
    points: [
      "Every recommendation is grounded in quantitative analysis — growth trends, yield metrics, demographic shifts and supply constraints.",
      "I remove emotional bias from the buying process.",
      "Decisions are based on evidence, not market noise."
    ]
  },
  {
    title: "Disciplined Selection",
    points: [
      "I say no to more properties than I recommend.",
      "A structured framework filters poor-quality assets before they reach you.",
      "Focus on fundamentals that drive long-term performance."
    ]
  },
  {
    title: "Downside Protection",
    points: [
      "Avoiding overpaying is as important as finding the right property.",
      "I assess resale risk, liquidity and exit strategy before recommending any asset.",
      "Protect capital first — growth follows from sound decisions."
    ]
  }
];

export const process = [
  { n: "01", title: "Getting Aligned", desc: "We start by understanding your goals, risk tolerance, budget and timeframe before anything else." },
  { n: "02", title: "Market & Suburb Research", desc: "I identify suitable markets and suburbs based on long-term fundamentals, not short-term hype." },
  { n: "03", title: "Finding the Right Properties", desc: "I source and filter properties against strict criteria, rejecting anything that doesn't meet our standards." },
  { n: "04", title: "Due Diligence", desc: "Each shortlisted property is carefully assessed before we recommend moving forward." },
  { n: "05", title: "Securing the Property", desc: "I handle negotiations and contract execution with a focus on protecting your position." },
  { n: "06", title: "Settlement & Handover", desc: "I coordinate the process through to settlement to ensure a smooth and controlled handover." }
];

export const services = [
  { icon: "Map", title: "Market & Suburb Research", desc: "Real data — not hype — so every property is backed by strong fundamentals." },
  { icon: "Filter", title: "Property Selection", desc: "Only investment-grade properties that fit your goals make the shortlist." },
  { icon: "ClipboardCheck", title: "Due Diligence", desc: "Price, condition, risks and rentability — no surprises after settlement." },
  { icon: "Handshake", title: "Negotiation", desc: "All agent communication handled to secure the right property at the right price." },
  { icon: "FileSignature", title: "Contract & Settlement", desc: "From contract review to settlement — nothing slips through the cracks." },
  { icon: "LifeBuoy", title: "Ongoing Support", desc: "Property manager intros and future portfolio decisions, beyond settlement." }
];

export const posts = [
  {
    slug: "data-driven-property-buying-2026",
    title: "Why Data-Driven Property Buying Outperforms in 2026",
    date: "Jan 18, 2026",
    excerpt: "Yield compression and supply constraints make rigorous suburb analysis non-negotiable. Here's the framework I use for every client.",
    image: "https://images.unsplash.com/photo-1638885930125-85350348d266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4MDg4NzY4NXww&ixlib=rb-4.1.0&q=85",
    body: [
      "The investors winning in 2026 aren't the ones with the biggest budgets — they're the ones with the most disciplined frameworks. After two years of compressed yields and uneven capital growth across Australian markets, intuition alone is a losing strategy.",
      "Every property I recommend passes a three-stage filter: macro market positioning, suburb-level supply/demand signals, and asset-level downside risk. If any stage flags concern, the property is out — regardless of how attractive the price looks.",
      "The result is a portfolio that compounds quietly while others chase the next hot postcode."
    ]
  },
  {
    slug: "regional-vs-metro-2026",
    title: "Regional vs Metro: Where Are the Real Yields in 2026?",
    date: "Jan 04, 2026",
    excerpt: "Regional Queensland is quietly outperforming many metro pockets. But not all regional markets are equal — here's how to read them.",
    image: "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBob3VzZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc4MDg4NzY4NXww&ixlib=rb-4.1.0&q=85",
    body: [
      "Headlines lump 'regional Australia' into one number. That's lazy analysis. The data shows a 12-point spread between top-performing and bottom-performing regional LGAs over the last 18 months.",
      "I look at population trajectory, employment diversity, infrastructure pipeline and rental vacancy in parallel. Strong on three out of four? Worth a deeper look. Two? Pass.",
      "Investment-grade regional properties exist — but you have to do the work to find them."
    ]
  },
  {
    slug: "due-diligence-checklist",
    title: "The Due Diligence Items Most Investors Skip",
    date: "Dec 12, 2025",
    excerpt: "Building & pest is the floor — not the ceiling. Here are the seven checks I run before any contract is signed.",
    image: "https://images.pexels.com/photos/7174386/pexels-photo-7174386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Most buyers stop at building & pest, strata search and a title check. That's a baseline, not a strategy.",
      "Real diligence means understanding the suburb's planning overlays, recent comparable sales (not asking prices), the property's rental history, council infrastructure plans within 5km, flood and bushfire mapping, and the listing agent's negotiation patterns.",
      "It takes time. It's also the difference between a property that performs and one that quietly drags your portfolio for a decade."
    ]
  }
];

export const fmtCurrency = (n) => {
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n}`;
};
